import { themeColors } from 'utilities/colors';

import useTheme, { THEME_DARK } from './useTheme';

const useThemeColors = () => {
  const theme = useTheme();

  if (theme === THEME_DARK) {
    return themeColors.dark;
  }

  return themeColors.light;
};

export default useThemeColors;
